
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type MessagingGetChatMessages200PageAllOfThreeContentItemAllOfOnezeroMediaLinksItemLinkType = typeof MessagingGetChatMessages200PageAllOfThreeContentItemAllOfOnezeroMediaLinksItemLinkType[keyof typeof MessagingGetChatMessages200PageAllOfThreeContentItemAllOfOnezeroMediaLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessagingGetChatMessages200PageAllOfThreeContentItemAllOfOnezeroMediaLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
